<template>
    <div>
        <slot :open="open" :close="close" name="modal-trigger"/>
        <portal v-if="portalOpen" to="modal">
            <transition :name="instantTransition ? '' : 'modal-animation'" @after-leave="afterClose">
                <div v-show="isOpen" class="component-modal">
                    <div class="modal-overlay">
                        <div
                            ref="modal-wrapper"
                            class="modal-wrapper"
                            @click="handleWrapperClick($event)"
                        >
                            <div
                                :class="modalContainerClasses"
                                class="modal-container container"
                            >
                                <button class="modal-close" @click="close">
                                    <slot name="modal-close">
                                        <i class="app-icon-cancel" />
                                    </slot>
                                </button>

                                <div
                                    v-if="prevModalId || prevModalId === 0"
                                    class="modal-arrow left"
                                    @click="prevModal"
                                />
                                <div
                                    v-if="nextModalId || nextModalId === 0"
                                    class="modal-arrow right"
                                    @click="nextModal"
                                />

                                <slot :close="close" name="modal-content"/>

                                <div v-if="parseInt(modalCount) > 0" class="modals-navigation">
                                    <button
                                        v-for="n in parseInt(modalCount)"
                                        :key="n"
                                        :class="{ 'active': modalInd == n-1 }"
                                        class="modal-navigation-dot"
                                        @click="gotoModalInd(n-1)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </portal>
    </div>
</template>

<script>
import { KEY_ESCAPE, KEY_LEFT, KEY_RIGHT } from 'keycode-js';
import Cookies from 'js-cookie';
import modalBus from '../modalBus';

export default {
    name: 'AppModal',
    props: {
        type: {
            type: String,
            default: 'content',
        },
        modalId: {
            type: String,
            default: null,
        },
        modalInd: {
            type: String,
            default: null,
        },
        nextModalId: {
            type: String,
            default: null,
        },
        prevModalId: {
            type: String,
            default: null,
        },
        modalCount: {
            type: String,
            default: null,
        },
        modalGroupId: {
            type: String,
            default: null,
        },
        autoPop: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isOpen: false,
        portalOpen: false,
        instantTransition: false,
    }),
    computed: {
        modalContainerClasses() {
            let classes;
            if (this.type === 'inspiration') {
                classes = 'modal-inspiration modal-small';
            }
            if (this.type === 'embed') {
                classes = 'modal-embed';
            }

            if (this.type === 'small') {
                classes = 'modal-small';
            }

            if (this.type === 'content') {
                classes = 'modal-content';
            }

            if (this.type === 'newsletter') {
                classes = 'modal-content newsletter';
            }

            return classes;
        },
    },
    mounted() {
        window.addEventListener('keyup', this.handleKeypress.bind(this));

        modalBus.$on('modalNav', (modalId) => {
            if (modalId === this.modalId) this.open(null, true);
            else if (this.isOpen) this.close(true);
        });

        if (this.autoPop) {
            const lastPop = Cookies.get(`autopopped-${this.modalId}`);
            if (!lastPop) {
                setTimeout(() => {
                    this.open();
                    Cookies.set(`autopopped-${this.modalId}`, 1, { expires: 3 });
                }, 30000);
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress);
        modalBus.$off('modalNav');
    },
    methods: {
        close(instant) {
            this.isOpen = false;
            this.instantTransition = false;
            if (instant) {
                this.afterClose();
            }
        },
        afterClose() {
            this.portalOpen = false;
            this.$emit('close');
        },
        open(event, instant) {
            if (event) {
                event.currentTarget.blur();
            }

            if (instant) this.instantTransition = true;

            this.portalOpen = true;
            setTimeout(() => {
                this.isOpen = true;
                this.$emit('open');
            }, 0);
        },
        handleKeypress(event) {
            if (!this.isOpen) return;

            switch (event.keyCode) {
            case KEY_ESCAPE:
                this.close();
                break;
            case KEY_LEFT:
                this.prevModal();
                break;
            case KEY_RIGHT:
                this.nextModal();
                break;
            default:
                // nothing, but linter says I gotta have it.
            }
        },
        swipeHandler(direction) {
            if (!this.isOpen) return;

            if (direction === 'left') {
                this.nextModal();
            }
            if (direction === 'right') {
                this.prevModal();
            }
        },
        handleWrapperClick(event) {
            if (event.target.className === 'modal-wrapper') {
                this.close();
            }
        },
        nextModal() {
            if (this.nextModalId) modalBus.$emit('modalNav', this.nextModalId);
        },
        prevModal() {
            if (this.prevModalId) modalBus.$emit('modalNav', this.prevModalId);
        },
        gotoModal(modalId) {
            modalBus.$emit('modalNav', `${modalId}`);
        },
        gotoModalInd(modalInd) {
            this.gotoModal(`${this.modalGroupId}-${modalInd}`);
        },
    },
};
</script>
